import { __makeTemplateObject } from "tslib";
import styled from 'styled-components';
export var Root = styled.div.withConfig({
  displayName: "ui-kit-Root",
  componentId: "ui-kit-1v2l6om"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &.rounded {\n    border-radius: 12px;\n  }\n"], ["\n  background-color: ", ";\n  box-shadow: ", ";\n\n  &.rounded {\n    border-radius: 12px;\n  }\n"])), function (_a) {
  var theme = _a.theme,
      background = _a.background;
  return theme.palette.background.neutral[background || 'primary'];
}, function (_a) {
  var theme = _a.theme,
      shadow = _a.shadow;
  return theme.palette.shadow[shadow || 'cardEasy'];
});
var templateObject_1;